<template>
  <div
    class="export-options__item"
    :class="{
      'export-options__item--selected': isSelected,
      'export-options__item--disabled': !hasConsent
    }"
    @click="updateSelectedOption"
  >
    <img
      height="24"
      width="24"
      :src="$images.CONNECTOR_LOGO(sourceId)"
      class="mr-2"
    /><span>{{ sourceName }}</span>
  </div>
</template>
<script>
export default {
  name: 'export-options-list-item',
  props: {
    sourceDetails: {
      type: Object,
      required: true
    },
    selectedOption: {
      type: String,
      required: true
    }
  },
  computed: {
    sourceName() {
      return this.sourceDetails?.SOURCE_NAME || '';
    },
    sourceId() {
      return this.sourceDetails?.SOURCE_ID || '';
    },
    hasConsent() {
      return this.sourceDetails?.HAS_CONSENT || false;
    },
    isSelected() {
      return this.sourceId === this.selectedOption && this.hasConsent;
    }
  },
  methods: {
    updateSelectedOption() {
      // Don't update selected option when user click on disabled or selected option
      if (!this.hasConsent || this.isSelected) {
        return;
      }
      this.$emit('updateSelectedOption', this.sourceId);
    }
  }
};
</script>
